<template>
	<el-main class="materialwrap">
		<div class="mybread">
			<p><i class="el-icon-location"></i>当前位置：</p>
			<el-breadcrumb separator-class="el-icon-arrow-right">
				<el-breadcrumb-item>其他管理</el-breadcrumb-item>
				<el-breadcrumb-item :to="{ path: '/asset' }">物品管理</el-breadcrumb-item>
				<el-breadcrumb-item>物品管理详情</el-breadcrumb-item>
			</el-breadcrumb>
		</div>

		<div class="header">
			<div class="header-info">
				<h1>{{ form.asset_name }}{{ `- ${form.secondary_name}` }}</h1>
				<p style="font-size: 20px; font-weight: 550;">{{ form.cate_name }} </p>
				<p>序列码：{{ form.serial_no }} </p>
				<p style="white-space: pre-wrap;">规格型号：{{ form.spec_model }} </p>
				<p style="color: var(--text-2); /* 0819修改 */;">购置时间：{{ form.purchase_date }} </p>
			</div>
			<div class="header-status">
				<div style="margin-right: 10px;">
					<el-button round style="text-align: center;" @click="statusChangeShow = true"
						v-if="NodeInclude('405')">申请过期</el-button>
				</div>
				<div>
					<div class="button" :style="{ 'backgroundColor': dd.assetStatus_c[form.status]?.color }">
						{{ dd.assetStatus_c[form.status]?.word }}
					</div>
				</div>
			</div>
		</div>
		<!-- 物品详情 -->
		<div class="base1">
			<h3 class="ntitle">物品详情</h3>
			<div class="operater">
				<div class="linkline" @click="link(`/asset/add?id=${query.id}`)" v-if="NodeInclude('396')">编辑</div>
				<div class="linkbox" style="margin-left: 15px;" v-if="form.fixed_approval?.status == '0' && NodeInclude('434')"
					@click="fixCheckShow = true">固定资产审核</div>
				<div class="linkbox" style="margin-left: 15px;"
					v-if="form.is_consumable == '0' && form.is_fixed == '1' && form.asset_status == '1' && form.scrap_approval?.status != '0' && NodeInclude('431')"
					@click="applyScrapShow = true">申请报废</div>
				<div class="linkline"
					v-if="form.is_consumable == '0' && form.is_fixed == '1' && form.scrap_approval?.status == '0'">
					{{ `固定资产报废${form.scrap_approval?.status_text}...` }}
				</div>
				<div class="linkbox" style="margin-left: 15px;" v-if="form.scrap_approval?.status == '0' && NodeInclude('432')"
					@click="scrapCheckShow = true">报废审核</div>
			</div>
			<ul>
				<li>
					<p>
						<label>物品编号：</label><a>{{ form.asset_code }}</a>
					</p>
					<p>
						<label>购置金额：</label><a style="white-space: pre-wrap;">{{ (form.asset_price) }}</a>
					</p>
					<p>
						<label>物品类型：</label><a>{{ form.is_consumable == '0' ? (form.is_fixed == '1' ? '固定物品' : '非消耗品') : '消耗品' }} <i
								class="el-icon-edit" style="cursor: pointer" @click="ChangeShowFn" v-if="NodeInclude('429')"></i></a>
					</p>
					<p v-if="form.is_consumable == '0' && form.is_fixed == '1'">
						<label>获取编号：</label>
						<a style="width: 100%;">
							<el-col :span="12">
								{{ form.fixed_asset_no ? form.fixed_asset_no : '暂无固定资产编号' }}
							</el-col>
							<el-col :span="4">
								<el-button round style="text-align: center;" @click="getFixedAssetNo"
									v-if="!form.fixed_asset_no && NodeInclude('435')">自动获取</el-button>
							</el-col>
						</a>
					</p>
					<p>
						<label>备注：</label><a style="white-space: pre-wrap;">{{ form.remark }}</a>
					</p>
					<p>
						<label>附件：</label>
						<template>
							<ul class="bbox">
								<li v-for="(item, index) in fileList" :key="index">
									<el-col :span="24" v-if="item.origin_name">
										<el-col :span="20">
											<div class="origin-name">{{ item.origin_name }}</div>
										</el-col>
										<el-col :span="4">
											<el-link type="primary" style="margin-right:5px" :href="item.httpFile"
												target="_blank">查看</el-link>
										</el-col>
									</el-col>
								</li>
							</ul>
						</template>
					</p>
				</li>
				<li>
					<p>
						<label>物品归属：</label><a>{{ dd.assetbelong_type[form.belong_type] }}</a>
					</p>
					<p>
						<label>购置数量：</label><a style="white-space: pre-wrap;">{{ form.asset_count }}</a>
					</p>
					<p v-if="form.is_consumable == '0'">
						<template v-if="Object.keys(form.fixed_approval)?.length == 0">
							<label>固定资产申请：</label>
							<a>
								<el-button type="primary" round style="text-align: center;" @click="ChangeFixShowFn">点击申请</el-button>
							</a>
						</template>
					</p>
					<p v-if="form.is_consumable == '0' && form.is_fixed == '1'">
						<label>固定资产状态：</label>
						<a>
							<div class="circle-tag" :style="{ 'background': dd.assetStayStatus_c[form.asset_status]?.color }">
								<div class="word">{{ dd.assetStayStatus_c[form.asset_status]?.word }}</div>
							</div>
						</a>
					</p>
					<p v-if="form.is_consumable == '0' && form.is_fixed == '1'">
						<template v-if="form.asset_status == '4'">
							<label>部分报废数量：</label>
							<a>{{ form.scrapped_count }}</a>
						</template>
					</p>
				</li>
			</ul>
		</div>
		<!-- 领用信息 -->
		<div class="base1">
			<h3 class="ntitle">领用详情</h3>
			<div class="operater">
				<div class="linkbox" :class="{ 'grey': form.status == '3' || form.use_status == '1' }" @click="showReceive"
					v-if="NodeInclude('408')">领用
				</div>
				<div class="linkbox" :class="{ 'grey': form.use_status == '0' }" style="margin-left: 15px;" @click="showReturn"
					v-if="form.is_consumable == '0' && form.use_record?.length != 0 && NodeInclude('427')">归还</div>
			</div>
			<ul style="background: var(--card); /* 0819修改 */">
				<li>
					<p>
						<label>物品总数：</label>
						<a>{{ form.asset_count }}</a>
					</p>
					<p>
						<label>领用状态：</label>
						<a>
							<div class="circle-tag" :style="{ 'background': dd.assetUseStatus_c[3]?.color }"
								v-if="form.status == '3'">
								<div class="word">{{ dd.assetUseStatus_c[3]?.word }}</div>
							</div>
							<div class="circle-tag" :style="{ 'background': dd.assetUseStatus_c[form.use_status]?.color }" v-else>
								<div class="word">{{ dd.assetUseStatus_c[form.use_status]?.word }}</div>
							</div>
						</a>
					</p>

				</li>
				<li>
					<p>
						<label>可用数量：</label>
						<a>{{ form.available_count }}</a>
					</p>
					<p>
					</p>

				</li>
			</ul>
			<template>
				<ul v-for="(item, index) in useRecordList" :key="`urlist${index}`">
					<li>
						<p>
							<label>领用人:</label>
							<a>{{ item.user?.realname }} {{ item.user?.en_name }}</a>
						</p>
						<p>
							<label>领用数量:</label>
							<a>{{ item.use_count }}</a>
						</p>
					</li>
					<li>
						<p>
							<label>领用时间:</label>
							<a>{{ item.receive_time }}</a>
						</p>
						<p>
							<label>备注:</label>
							<a style="white-space: pre-wrap;">{{ item.remark }}</a>
						</p>
					</li>
				</ul>
			</template>
		</div>
		<!-- 关联项目 -->
		<div class="base1">
			<h3 class="ntitle">{{ dd.assetbelong_type[form.belong_type] }}采购</h3>
			<ul>
				<li>
					<p>
						<label>关联{{ dd.assetbelong_type[form.belong_type] }}：</label>
						<a v-if="Object.keys(form.project_pay_info)?.length == '0'">暂无</a>
						<a class="linkwrap normal"
							@click="link(`/adminPay/view?id=${form.project_pay_info?.pay_id}&cid=${form.project_pay_info?.project_id}&mType=${form.belong_type}`)"
							v-else>
							<el-link>{{ form.project_pay_info?.contract_no }} - {{ form.project_pay_info?.project_name }} - {{
								form.project_pay_info?.son_project_name }}</el-link>
						</a>
					</p>
				</li>
				<li>
					<p></p>
				</li>
			</ul>
		</div>
		<!-- 发票信息 -->
		<div class="base1" v-if="Object.keys(form.project_pay_info)?.length == '0'">
			<h3 class="ntitle">发票信息</h3>
			<div class="operater">
				<div class="linkline" @click="link(`/asset/invoice?id=${query.id}`)" v-if="form.invoiceList.length != 0">编辑
				</div>
			</div>
			<template v-if="form.invoiceList.length == 0">
				<div class="inblank">
					<el-button class="ibtn" icon="el-icon-plus" circle @click="link(`/asset/invoice?id=${query.id}`)"></el-button>
					<p>该项目暂无发票信息，点击创建</p>
				</div>
			</template>
			<template v-else>
				<ul v-for="(item, index) in form.invoiceList" :key="index">
					<li>
						<p>
							<label>发票代码：</label><a>{{ item.invoice_code ? item.invoice_code : '暂无' }}</a>
						</p>
						<p>
							<label>金额：</label><a>{{ item.invoice_amount ? item.invoice_amount : '暂无' }}</a>
						</p>
						<p>
							<label>发票附件：</label>
							<template>
								<ul class="bbox">
									<li v-for="(_it, _id) in item.atta_str" :key="_id">
										<el-col :span="24" v-if="_it.origin_name">
											<el-col :span="20">
												<div class="origin-name">{{ _it.origin_name }}</div>
											</el-col>
											<el-col :span="4">
												<el-link type="primary" style="margin-right:5px" :href="_it.httpFile"
													target="_blank">查看</el-link>
											</el-col>
										</el-col>
										<el-col v-else>暂无附件</el-col>
									</li>
								</ul>
							</template>
						</p>
						<p>
							<label>发票状态：</label><a>{{ item.status == 1 ? '正常' : (item.status == 2 ? '作废' : '暂无') }}</a>
						</p>
					</li>
					<li>
						<p>
							<label>发票号码：</label><a>{{ item.invoice_no ? item.invoice_no : '暂无' }}</a>
						</p>
						<p>
							<label>发票日期：</label><a>{{ item.invoice_date ? item.invoice_date : '暂无' }}</a>
						</p>
					</li>
				</ul>
			</template>
		</div>
		<!-- 项目动态 -->
		<div class="history">
			<h3 class="ntitle">项目动态</h3>
			<el-form ref="trackForm" :model="trackForm" style="float:right;">
				<el-form-item label="" prop="track_event">
					<el-col :span="20">
						<el-select v-model="trackForm.event_id" placeholder="请选择流程" style="margin-right: 0; width: 100%;"
							@change="trackChange">
							<el-option label="全部流程" value="0"></el-option>
							<el-option label="库存管理" value="18"></el-option>
							<el-option label="物品管理" value="19"></el-option>
							<el-option label="固定资产管理" value="20"></el-option>
						</el-select>
					</el-col>
				</el-form-item>
			</el-form>
			<ul class="linehead">
				<li>时间</li>
				<li>操作人</li>
				<li>流程</li>
				<li>详情</li>
			</ul>
			<div class="timeline">
				<el-timeline>
					<el-timeline-item :timestamp="compDate(item)" placement="top" v-for="(item, index) in myTrackList"
						:key="index" :class="{ child: !item.parent }" :icon="item.icon" :color="item.color">
						<div class="ico-edit" v-if="NodeInclude('410') || NodeInclude('411')">
							<el-dropdown trigger="click" placement="bottom-start" @command="handleCommand">
								<i class="el-icon-edit" @click="setTimeForm(item)"></i>
								<template #dropdown>
									<el-dropdown-menu>
										<el-dropdown-item command="a" v-if="NodeInclude('410')">新增</el-dropdown-item>
										<el-dropdown-item command="b" v-if="NodeInclude('410')">编辑</el-dropdown-item>
										<el-dropdown-item command="c" v-if="NodeInclude('411')">删除</el-dropdown-item>
									</el-dropdown-menu>
								</template>
							</el-dropdown>
						</div>
						<div class="mycard" :class="{ active: parentActive(item), parent: item.parent }" @click="trigger(item)">
							<!-- {{item}} -->
							<i class="point" v-if="item.point">+{{ item.point }}</i>
							<div v-if="!item.parent">
								<ul class="ul">
									<li>
										<span>{{ item.bkUserArr ? item.bkUserArr.realname : '暂无' }}</span>
									</li>
									<li>
										<span>{{ item.eventName }}</span>
									</li>
									<li v-html="item.info"></li>
								</ul>
							</div>
						</div>
					</el-timeline-item>
				</el-timeline>
			</div>
		</div>

		<el-dialog title="申请过期" :visible.sync="statusChangeShow" width="600px">
			<ul class="aul ulist" style="padding:0">
				<li>
					<span>物品总数：</span>
					<span style="padding: 0 30px;">{{ form.asset_count }}</span>
				</li>
				<li>
					<span>已过期数量：</span>
					<span style="padding: 0 30px;">{{ form.expired_count }}</span>
				</li>
				<el-form ref="statusChangeForm" :model="statusChangeForm" label-width="140px" label-position="left"
					class="ulform">
					<el-form-item label="过期数量：" prop="use_count">
						<el-col :span="24">
							<el-input placeholder="请输入" maxlength="100" v-model="statusChangeForm.expired_count" clearable />
						</el-col>
					</el-form-item>
				</el-form>
			</ul>
			<span slot="footer" class="dialog-footer">
				<el-button @click="statusChangeShow = false">取 消</el-button>
				<el-button type="primary" @click="changeStatusFn">确 定</el-button>
			</span>
		</el-dialog>

		<el-dialog title="修改物品类型" :visible.sync="assetChangeShow" width="600px">
			<ul class="aul ulist" style="padding:0">
				<el-form ref="assetChangeForm" :model="assetChangeForm" label-width="140px" label-position="left"
					class="ulform">
					<el-form-item label="修改物品类型备注：" prop="consumable_remark">
						<el-col :span="24">
							<el-input type="textarea" spellcheck="false" :autosize="{ minRows: 4 }" placeholder="请输入内容"
								v-model="assetChangeForm.consumable_remark">
							</el-input>
						</el-col>
					</el-form-item>
				</el-form>
			</ul>
			<span slot="footer" class="dialog-footer">
				<el-button @click="assetChangeShow = false">取 消</el-button>
				<el-button type="primary" @click="changeAssetTypeFn">确 定</el-button>
			</span>
		</el-dialog>

		<el-dialog title="申请固定资产" :visible.sync="fixChangeShow" width="600px">
			<ul class="aul ulist" style="padding:0">
				<el-form ref="fixChangeForm" :model="fixChangeForm" label-width="140px" label-position="left" class="ulform">
					<el-form-item label="申请固定资产备注：" prop="apply_remark">
						<el-col :span="24">
							<el-input type="textarea" spellcheck="false" :autosize="{ minRows: 4 }" placeholder="请输入内容"
								v-model="fixChangeForm.apply_remark">
							</el-input>
						</el-col>
					</el-form-item>
				</el-form>
			</ul>
			<span slot="footer" class="dialog-footer">
				<el-button @click="fixChangeShow = false">取 消</el-button>
				<el-button type="primary" @click="changeAssetTypeFixFn">确 定</el-button>
			</span>
		</el-dialog>

		<el-dialog title="固定资产申请报废" :visible.sync="applyScrapShow" width="600px">
			<ul class="aul ulist" style="padding:0">
				<li>
					<span>可用数量：</span>
					<span style="padding: 0 30px;">{{ form.available_count }}</span>
				</li>
				<el-form ref="applyScrapForm" :model="applyScrapForm" label-width="140px" label-position="left" class="ulform">
					<el-form-item label="报废数量：" prop="use_count">
						<el-col :span="24">
							<el-input placeholder="请输入" maxlength="100" v-model="applyScrapForm.scrap_count" clearable />
						</el-col>
					</el-form-item>
					<el-form-item label="报废备注：" prop="apply_remark">
						<el-col :span="24">
							<el-input type="textarea" spellcheck="false" :autosize="{ minRows: 4 }" placeholder="请输入内容"
								v-model="applyScrapForm.apply_remark">
							</el-input>
						</el-col>
					</el-form-item>
				</el-form>
			</ul>
			<span slot="footer" class="dialog-footer">
				<el-button @click="applyScrapShow = false">取 消</el-button>
				<el-button type="primary" @click="applyScrapFn">确 定</el-button>
			</span>
		</el-dialog>

		<el-dialog title="固定资产审核" :visible.sync="fixCheckShow" width="600px">
			<ul class="aul ulist" style="padding:0">
				<el-form ref="fixCheckForm" :model="fixCheckForm" label-width="140px" label-position="left" class="ulform">
					<el-form-item label="审核：" prop="leader_check_status">
						<el-col :span="24">
							<el-radio-group v-model="fixCheckForm.action">
								<el-radio label="1">通过</el-radio>
								<el-radio label="0">拒绝</el-radio>
							</el-radio-group>
						</el-col>
					</el-form-item>
					<el-form-item label="备注：" prop="remark">
						<el-col :span="24">
							<el-input type="textarea" spellcheck="false" :autosize="{ minRows: 4 }" placeholder="请输入内容"
								v-model="fixCheckForm.remark">
							</el-input>
						</el-col>
					</el-form-item>
				</el-form>
			</ul>
			<span slot="footer" class="dialog-footer">
				<el-button @click="fixCheckShow = false">取 消</el-button>
				<el-button type="primary" @click="handleFixCheckFn">确 定</el-button>
			</span>
		</el-dialog>

		<el-dialog title="报废审核" :visible.sync="scrapCheckShow" width="600px">
			<ul class="aul ulist" style="padding:0">
				<el-form ref="scrapCheckForm" :model="scrapCheckForm" label-width="140px" label-position="left" class="ulform">
					<el-form-item label="审核：" prop="leader_check_status">
						<el-col :span="24">
							<el-radio-group v-model="scrapCheckForm.action">
								<el-radio label="1">通过</el-radio>
								<el-radio label="0">拒绝</el-radio>
							</el-radio-group>
						</el-col>
					</el-form-item>
					<el-form-item label="备注：" prop="remark">
						<el-col :span="24">
							<el-input type="textarea" spellcheck="false" :autosize="{ minRows: 4 }" placeholder="请输入内容"
								v-model="scrapCheckForm.remark">
							</el-input>
						</el-col>
					</el-form-item>
				</el-form>
			</ul>
			<span slot="footer" class="dialog-footer">
				<el-button @click="scrapCheckShow = false">取 消</el-button>
				<el-button type="primary" @click="handleScrapCheckFn">确 定</el-button>
			</span>
		</el-dialog>

		<el-dialog title="物品领用" :visible.sync="receiveAssetShow" width="600px">
			<ul class="aul ulist" style="padding:0">
				<el-form ref="receiveAssetForm" :model="receiveAssetForm" label-width="140px" label-position="left"
					class="ulform">
					<el-form-item label="领用人：" prop="user_id">
						<el-col :span="24">
							<el-select v-model="receiveAssetForm.user_id" placeholder="请选择" style="width: 100%;">
								<el-option :label="`${v.realname} ${v.en_name}`" :value="v.id" v-for="(v, i) in receiveUserList"
									:key="i"></el-option>
							</el-select>
						</el-col>
					</el-form-item>
					<el-form-item label="领用数量：" prop="use_count">
						<el-col :span="24">
							<el-input placeholder="请输入" maxlength="100" v-model="receiveAssetForm.use_count" clearable />
						</el-col>
					</el-form-item>
					<el-form-item label="备注：" prop="remark">
						<el-col :span="24">
							<el-input type="textarea" spellcheck="false" :autosize="{ minRows: 4 }" placeholder="请输入内容"
								v-model="receiveAssetForm.remark">
							</el-input>
						</el-col>
					</el-form-item>
				</el-form>
			</ul>
			<span slot="footer" class="dialog-footer">
				<el-button @click="receiveAssetShow = false">取 消</el-button>
				<el-button type="primary" @click="handleReceiveAssetFn">确 定</el-button>
			</span>
		</el-dialog>

		<el-dialog title="物品归还" :visible.sync="returnAssetShow" width="600px">
			<ul class="aul ulist" style="padding:0">
				<el-form ref="receiveAssetForm" :model="returnAssetForm" label-width="140px" label-position="left"
					class="ulform">
					<el-form-item label="领用记录：" prop="record_id">
						<el-col :span="24">
							<el-select v-model="returnAssetForm.record_id" placeholder="请选择" style="width: 100%;">
								<el-option :label="`${v.user?.realname} ${v.user?.en_name} 领用数：${v.use_count} 领用时间：${v.receive_time}`"
									:value="v.id" v-for="(v, i) in useRecordList" :key="`use_record${i}`"></el-option>
							</el-select>
						</el-col>
					</el-form-item>
					<el-form-item label="归还数量：" prop="use_count">
						<el-col :span="24">
							<el-input placeholder="请输入" maxlength="100" v-model="returnAssetForm.return_count" clearable />
						</el-col>
					</el-form-item>
					<el-form-item label="备注：" prop="condition_desc">
						<el-col :span="24">
							<el-input type="textarea" spellcheck="false" :autosize="{ minRows: 4 }" placeholder="请输入内容"
								v-model="returnAssetForm.condition_desc">
							</el-input>
						</el-col>
					</el-form-item>
				</el-form>
			</ul>
			<span slot="footer" class="dialog-footer">
				<el-button @click="receiveAssetShow = false">取 消</el-button>
				<el-button type="primary" @click="handleReturnAssetFn">确 定</el-button>
			</span>
		</el-dialog>

		<el-dialog :title="timeForm.option == 1 ? '新增物品动态' : '编辑物品动态'" :visible.sync="trackShow" width="600px">
			<el-form ref="timeForm" :model="timeForm" label-width="140px" label-position="left" class="ulform">
				<el-form-item label="选择时间：" prop="create_time">
					<el-col :span="24">
						<el-date-picker v-model="timeForm.create_time" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"
							placeholder="选择时间" style="width:100%;">
						</el-date-picker>
					</el-col>
				</el-form-item>
				<el-form-item label="选择操作人：" prop="bk_uid">
					<el-col :span="24">
						<el-select v-model="timeForm.bk_uid" placeholder="请选择" clearable filterable style="width:100%;">
							<el-option :label="`${v.en_name} ${v.realname}`" :value="v.id" v-for="(v, i) in userList"
								:key="i"></el-option>
						</el-select>
					</el-col>
				</el-form-item>
				<el-form-item label="选择流程：" prop="event_id">
					<el-col :span="24">
						<el-select v-model="timeForm.event_id" placeholder="请选择" style="width: 100%;">
							<el-option label="全部流程" value="0"></el-option>
							<el-option label="库存管理" value="18"></el-option>
							<el-option label="物品管理" value="19"></el-option>
							<el-option label="固定资产管理" value="20"></el-option>
						</el-select>
					</el-col>
				</el-form-item>
				<el-form-item label="备注：" prop="info">
					<el-col :span="24">
						<el-input style="width: 100%;" type="textarea" spellcheck="false" :autosize="{ minRows: 4 }"
							placeholder="请输入内容" v-model="timeForm.info">
						</el-input>
					</el-col>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="trackShow = false">取 消</el-button>
				<el-button type="primary" @click="handleTrack">确 定</el-button>
			</span>
		</el-dialog>

		<el-dialog title="删除物品动态" :visible.sync="delTrackShow" width="600px">
			<ul class="aul ulist" style="padding:0; min-height: 100px;">
				<li>
					<span>时间：</span>
					<span>{{ timeForm.create_time }}</span>
				</li>
				<li>
					<span>操作人：</span>
					<span>{{ timeForm.bkUserArr ? timeForm.bkUserArr.realname : '暂无' }}</span>
				</li>
				<li>
					<span>项目状态：</span>
					<span>{{ dd.track_type[timeForm.event_id] }}</span>
				</li>
				<li>
					<span>详情：</span>
					<span v-html="timeForm.info"></span>
				</li>
			</ul>
			<span slot="footer" class="dialog-footer">
				<el-button @click="delTrackShow = false">取 消</el-button>
				<el-button type="primary" @click="deleteTrack">确 定</el-button>
			</span>
		</el-dialog>

	</el-main>
</template>

<script>
import * as api from '@/api'
import { timeFormat } from '@/utils/index.js'
import store from '@/store'
import { thousands } from '@/utils/index.js'
export default {
	name: 'assetView',
	data() {
		return {
			nodeLimtList: [],
			level: '',
			userId: '',
			userList: [],
			receiveUserList: [],
			canGetNo: true,
			form: {
				asset_id: '', //物品ID（新增为空，编辑必填）
				category_id: '',
				category_id_arr: [],
				belong_type: '2',
				is_consumable: '0',
				status: '1',
				invoiceList: [
					{ invoice_no: '', invoice_code: '', invoice_amount: '', invoice_date: '', atta_str: [{ origin_name: '', file_name: '', httpFile: '', id: '', flist: [] }], }
				],
				fixed_approval: {},//固定资产申请流程
				scrap_approval: {},//固定资产报废申请流程
				project_pay_info: {},
			},
			fileList: [
				{ origin_name: '', file_name: '', httpFile: '', file_id: '', flist: [] }
			],
			statusChangeShow: false,
			statusChangeForm: {
				expired_count: '0',
			},
			assetChangeShow: false,
			assetChangeForm: {
				consumable_remark: '',
			},
			fixChangeShow: false,
			fixChangeForm: {
				apply_remark: '',
			},
			applyScrapShow: false,
			applyScrapForm: {
				scrap_count: '',
				apply_remark: '',
			},
			fixCheckShow: false,
			fixCheckForm: {
				action: '0', //1通过，0拒绝
				remark: '',
			},
			scrapCheckShow: false,
			scrapCheckForm: {
				action: '0', //1通过，0拒绝
				remark: '',
			},
			receiveAssetShow: false,
			receiveAssetForm: {
				user_id: '',
				user_count: '',
				remark: '',
			},
			returnAssetShow: false,
			returnAssetForm: {
				asset_condition: '1',
				record_id: '',
				return_count: '',
				condition_desc: '',
			},
			//动态相关
			trackForm: {
				project_id: '',
				event_id: '',
			},
			delTrackShow: false,
			timeForm: {
				track_id: '',
				create_time: '',
				bk_uid: '',
				event_id: '',
				info: '',
				option: 1,
			},
			trackList: [],
			trackShow: false,
			currTrack: {//当前动态

			},
			useRecordList: [],
		}
	},
	computed: {
		parentActive() {
			return (item) => {
				return item.parent && item.active
			}
		},
		myTrackList() {
			return this.trackList.filter((item) => item)
		},
	},
	created() {
		this.query = this.$route.query
		this.query.id && this.getDetail(this.query.id)
	},
	mounted() {
		this.getUserList()
	},
	watch: {

	},
	methods: {
		checkUrlFn() {
			// 获取当前URL的哈希部分
			const hash = window.location.hash;
			// 移除'#'字符
			const url = hash.substring(1);
			let postData = {
				url_path: url
			}
			api.checkLoginUrl(postData).then((res) => {
				if (res.status == 400) {
					this.$message({
						type: 'info',
						message: '暂无权限',
					})
					this.$router.push({
						path: `/home`
					});
				}
			})
		},
		checkNodeFn(menu_id) {
			let postData = {
				menu_id,
			}
			api.checkNode(postData).then((res) => {
				this.nodeLimtList = res.node_ids.split(',')
			})
		},
		NodeInclude(val) {
			return this.nodeLimtList.includes(val)
		},
		async getUserList() {
			this.$fly
				.post('apiAccount_getUserList.html', {
					per_page: 5000,
				})
				.then((res) => {
					this.userList = res.itemList
				})
		},
		getReceiveUserList() {
			const that = this;
			return new Promise(function (resolve) {
				that.$fly.post("ApiAsset_getReceiveUserList.html", { asset_id: that.query.id }).then((res) => {
					that.receiveUserList = res.length ? res : [];
					resolve(that.receiveUserList)
				});
			})
		},
		getDetail(id) {
			this.checkUrlFn()
			this.checkNodeFn('61')
			const apiUrl = 'apiAsset_getAssetInfo.html'
			this.$fly
				.post(apiUrl, {
					asset_id: id,
				})
				.then((res) => {
					this.trackList = res.track_list
					// const atta_str = () => [{ origin_name: '', file_name: '', httpImg: '', id: '', flist: [] }]
					let form = res
					form.asset_price = thousands(form.asset_price)
					const atta_str = () => [{ origin_name: '', file_name: '', httpFile: '', id: '', flist: [] }]
					this.fileList = res.file_list
					//防空情况
					if (this.fileList.length === 0) {
						this.fileList = [{ origin_name: '', file_name: '', httpFile: '', id: '', flist: [] }]
					}
					this.form.invoiceList = res.invoiceList?.map((item) => {
						item.invoice_date = timeFormat(item.invoice_date)
						item.invoice_amount = thousands(item.invoice_amount)
						item.atta_str = item.fileList.length != 0 ? item.fileList : atta_str()
						return item
					})
					//防空情况
					if (res.invoiceList.length == 0) {
						this.form.invoiceList = [{ invoice_no: '', invoice_code: '', invoice_amount: '', invoice_date: '', atta_str: atta_str() }]
					}
					this.useRecordList = form.use_record || []
					this.form = form
					setTimeout(() => {
						//权限
						this.level = store.state.level
						this.userId = store.state.userId
					}, 200);
				})
		},
		changeStatusFn() {
			this.$fly
				.post('ApiAsset_setExpired.html', {
					asset_id: this.query.id,
					...this.statusChangeForm
				})
				.then((res) => {
					this.statusChangeShow = false
					if (res.message == '已通知财务变更物品状态') {
						this.$message.error(`${res.message}, 暂时无法变更`)
					}
					this.query.id && this.getDetail(this.query.id)
				})
		},
		getFixedAssetNo() {
			this.$fly
				.post('apiAsset_generateFixedAssetNo.html', {
					asset_id: this.query.id,
				})
				.then(() => {
					this.query.id && this.getDetail(this.query.id)
				})
		},
		ChangeShowFn() {
			if (Object.keys(this.form.fixed_approval)?.length) {
				this.$message.error(`固定资产${this.form.fixed_approval?.status_text}`)
				return false;
			}
			const that = this;
			that.assetChangeShow = true
		},
		changeAssetTypeFn() {
			this.$fly
				.post('ApiAsset_updateConsumable.html', {
					asset_id: this.query.id,
					is_consumable: this.assetChangeForm.is_consumable
				})
				.then(() => {
					this.assetChangeShow = false
					this.query.id && this.getDetail(this.query.id)
				})
		},
		ChangeFixShowFn() {
			const that = this;
			that.fixChangeShow = true
		},
		changeAssetTypeFixFn() {
			this.$fly
				.post('ApiAsset_applyFixedAsset.html', {
					asset_id: this.query.id,
					is_fixed: this.fixChangeForm.is_fixed
				})
				.then(() => {
					this.fixChangeShow = false
					this.query.id && this.getDetail(this.query.id)
				})
		},
		handleFixCheckFn() {
			this.$fly
				.post('ApiAsset_checkFixedAsset.html', {
					asset_id: this.query.id,
					...this.fixCheckForm
				})
				.then(() => {
					this.fixCheckShow = false
					this.query.id && this.getDetail(this.query.id)
				})
		},
		applyScrapFn() {
			this.$fly
				.post('ApiAsset_applyScrap.html', {
					asset_id: this.query.id,
					...this.applyScrapForm,
				})
				.then(() => {
					this.applyScrapShow = false
					this.query.id && this.getDetail(this.query.id)
				})
		},
		handleScrapCheckFn() {
			this.$fly
				.post('ApiAsset_scrapCheck.html', {
					asset_id: this.query.id,
					...this.scrapCheckForm
				})
				.then(() => {
					this.scrapCheckShow = false
					this.query.id && this.getDetail(this.query.id)
				})
		},
		showReceive() {
			if (this.form.status == '3') {
				this.$message.error('物品已过期')
				return false
			}
			if (this.form.use_status == '1') {
				this.$message.error('物品已全部领用')
				return false
			}
			this.receiveAssetForm = {
				user_id: '',
				user_count: '',
				remark: '',
			}
			this.getReceiveUserList().then(() => {
				this.receiveAssetShow = true
			})
		},
		handleReceiveAssetFn() {
			this.$fly
				.post('ApiAsset_receiveAsset.html', {
					asset_id: this.query.id,
					...this.receiveAssetForm
				})
				.then(() => {
					this.receiveAssetShow = false
					this.query.id && this.getDetail(this.query.id)
				})
		},
		showReturn() {
			if (this.form.use_status == '0') {
				this.$message.error('物品全部在库')
				return false
			}
			this.returnAssetForm = {
				asset_condition: '1',
				record_id: '',
				return_count: '',
				condition_desc: '',
			}
			this.returnAssetShow = true
		},
		handleReturnAssetFn() {
			this.$fly
				.post('ApiAsset_returnAsset.html', {
					asset_id: this.query.id,
					...this.returnAssetForm
				})
				.then(() => {
					this.returnAssetShow = false
					this.query.id && this.getDetail(this.query.id)
				})
		},
		//动态时间
		compDate(item) {
			return item.smartTime + '' + item.weekTime
		},
		trigger(item) {
			let date = item.date || {}
			this.trackList = this.trackList.map((v) => {
				if (v.date === date) {
					v.active = !v.active
				}
				return v
			})
		},
		trackChange(v) {
			this.$fly
				.post('ApiAsset_getTrackList.html', {
					project_id: this.query.id,
					event_id: v,
				})
				.then((res) => {
					this.trackList = res.trackList
				})
		},
		//修改项目动态
		setTimeForm(item) {
			console.log(item);
			const { bk_uid, create_time, event_id, id, info, bkUserArr } = item
			this.timeForm = {
				track_id: id,
				bk_uid,
				create_time,
				event_id,
				info,
				bkUserArr,
			}
		},
		handleCommand(command) {
			if (command == 'a') {
				this.timeForm = {
					track_id: '',
					bk_uid: '',
					create_time: '',
					event_id: '',
					info: '',
				}
				this.timeForm.option = 1
				this.timeForm.project_id = this.form.id
				this.trackShow = true
			}
			else if (command == 'b') {
				delete this.timeForm.bkUserArr
				this.timeForm.option = 2
				this.trackShow = true
			}
			else if (command == 'c') {
				console.log('c');
				this.delTrackShow = true
			}
		},
		handleTrack() {
			this.$fly
				.post('ApiAsset_editTrackInfo.html', {
					...this.timeForm,
				})
				.then((res) => {
					console.log(res);
					this.trackShow = false
					this.query.id && this.getDetail(this.query.id)
				})
		},
		deleteTrack() {
			this.$fly
				.post('ApiAsset_delTrack.html', {
					track_id: this.timeForm.track_id,
				})
				.then(() => {
					this.delTrackShow = false
					this.query.id && this.getDetail(this.query.id)
				})
		},
	},
}
</script>

<style lang="scss" scoped>
.header {
	//标题样式
	@extend %box;
	box-sizing: border-box;
	width: 100%;
	background: var(--card);
	/* 0819修改 */
	padding: 20px 40px;
	margin-bottom: 10px;
	@extend %center;
	flex-flow: row nowrap;
	justify-content: space-between;
	align-items: flex-start;

	.header-info {
		width: 80%;
		@extend %center;
		align-items: flex-start;
		text-align: left;

		h1 {
			font: 700 28px/1 $font;
			margin-bottom: 16px;
		}

		p {
			font: 16px/2 $font;

			&.info-detail {
				color: #999;
				font: 12px/2 $font;
				white-space: pre-wrap;
			}

			&.pdou {
				span {
					&::after {
						content: ',';
						display: inline-block;
					}

					&:last-of-type {
						&::after {
							display: none;
						}
					}
				}
			}
		}
	}

	.header-status {
		@extend %center;
		flex-flow: row nowrap;

		.button {
			box-sizing: border-box;
			min-width: 100px;
			border-radius: 20px;
			padding: 10px 15px;
			font: 12px/1 $font;
			color: #fff;
		}
	}
}

.materialwrap {
	.form.myform {
		padding-left: 100px;
	}

	.filterwrap {
		display: flex;
		justify-content: flex-end;
		padding: 0 0 15px 0;

		.el-button {
			margin: 0 0 0 20px;
		}
	}

	.base1 {
		@extend %box;
		margin-bottom: 20px;
		padding: 30px 40px;
		position: relative;

		.ntitle {
			display: inline-block;
			margin: 0 0 25px 0;

			&::before {
				width: 100%;
			}
		}

		ul {
			@extend %start;
			color: var(--text-1);
			/* 0819修改 */
			;
			background: var(--bg-soft);
			/* 0819修改 */
			padding: 0 25px;
			border-radius: 20px;
			margin-bottom: 20px;
			position: relative;

			&:last-of-type {
				margin-bottom: 0;
			}

			li {
				width: 50%;
				font: 14px/3 $font;

				p {
					min-height: 42px;
					padding: 5px 0;
					@extend %start;

					label {
						width: 150px;
						white-space: nowrap;
						flex: none;
					}

					.bbox {
						width: 100%;
						padding: 0;
						display: block;

						li {
							width: 100%;
							height: 42px;

							&:last-child {
								width: 100%;
								padding-left: 0;
							}
						}
					}

					.anlist {
						padding: 0;
						width: 100%;
						flex-flow: column nowrap;

						li {
							position: relative;
							width: 100%;

							.bbtn {
								position: absolute;
								top: 50%;
								left: 100%;
								transform: translateY(-50%)
							}
						}
					}

				}
			}
		}
	}
}

.aul.ulist {
	padding: 20px 0;
	font: 14px/2 $font;
	text-align: left;

	>li {
		padding: 0 60px;
		display: flex;
		flex-flow: row nowrap;

		span {
			display: inline-block;

			&:first-of-type {
				width: 30%;
			}

			&:last-of-type {
				width: 70%;
			}
		}
	}

	.ulform {
		padding: 0 60px;
	}

	.el-form-item--small.el-form-item {
		margin-bottom: 5px;
	}
}

.linkwrap {
	font-size: 12px;

	&.normal {
		color: #606266;

		a {
			color: #606266;

			&:hover {
				cursor: pointer !important;

				&::after {
					height: 0.2px;
					background-color: #606266;
				}
			}

			>span {
				font-size: 14px;
				color: #606266;
			}
		}

		span {
			color: var(--text-1);
			/* 0819修改 */
			;
			font-size: 16px;
			padding: 0 5px;
		}
	}
}

.inblank {
	@extend %center;
	font: 14px/2 $font;
	color: #999;
	background: var(--bg-soft);
	/* 0819修改 */
	padding: 25px;
	border-radius: 20px;
	margin-bottom: 20px;
	position: relative;
}

.operater {
	@extend %start;
	position: absolute;
	top: 30px;
	right: 40px;
	font: 14px/1 $font;
	text-align: center;

	>div {
		min-width: 32px;
		border: 1px solid #DCDFE6;
		border-radius: 3px;
		padding: 9px 10px;
		cursor: pointer;

		&.linkline {
			border-color: transparent;
			background: transparent;
			color: var(--text-1);
			/* 0819修改 */
			;

			&:hover {
				&::after {
					display: block;
					content: '';
					height: 0.1px;
					background: #231f20;
				}
			}
		}

		&.linkbox {
			border-color: #0E0F22;
			background: #0E0F22;
			color: #fff;

			&.grey {
				border-color: #c0c4cc;
				background: #c0c4cc;
				color: #fff !important;

				&:hover {
					background: #c0c4cc;
				}
			}

			&:hover {
				background: rgba($color: #0E0F22, $alpha: 0.8);
			}
		}
	}
}

.circle-tag {
	position: relative;
	top: 11px;

	&:hover {
		.word {
			padding: 0 10px;
		}
	}
}

.dialog-download {
	border-radius: 12px;
	background: #231f20;
	font: 12px/2 $font;
	color: #fff;
	padding: 5px 20px;
	margin: 0 20px;

	&:hover {
		color: #fff;
		background: rgba($color: #0E0F22, $alpha: 0.8);

		&::after {
			display: none;
		}
	}
}


.table {
	position: relative;
	margin-bottom: 20px;

	.expense {
		@extend %start;
		padding: 30px 0;

		>div {
			margin-right: 30px;
		}
	}

	.operater {
		.button {
			box-sizing: border-box;
			min-width: 100px;
			border-radius: 20px;
			padding: 10px 15px;
			font: 12px/1 $font;
			color: #fff;
			cursor: default;
		}
	}
}

.download {
	padding: 10px 0;
	@extend %start;
	justify-content: flex-end;
}

.history {
	@extend %box;
	padding: 30px 40px;
}
</style>

<style lang="scss">
.linehead {
	//时间版头样式
	display: flex;
	flex-flow: row nowrap;
	font: 16px/1 $font;
	color: var(--text-1);
	/* 0819修改 */
	padding: 25px 55px 0 60px;

	li {
		flex: auto;

		&:nth-child(1) {
			width: 190px;
			flex: none;
		}

		&:nth-child(2) {
			width: 190px;
			flex: none;
		}

		&:nth-child(3) {
			width: 190px;
			flex: none;
		}

		&:nth-child(4) {
			width: 880px;
			flex: none;
		}
	}
}

.timeline {
	//时间版内样式
	margin: 20px 25px 20px 30px;
	padding: 50px 30px;
	border-radius: 6px;
	border: solid 1px #bfbfbf;

	.ico-edit {
		display: block;
		width: 20px;
		height: 20px;
		z-index: 999 !important;
		position: absolute;
		left: -160px;
		top: 0px;
		cursor: pointer;

		::before {
			font-size: 20px;
			width: 20px;
			height: 20px;
		}
	}

	.mycard {
		min-height: 80px;
		background-color: var(--card);
		/* 0819修改 */
		border-radius: 4px;
		padding: 0 20px;
		position: relative;
		transform: translateY(-20px);
		// pointer-events: none;

		&.parent {
			pointer-events: auto;
			// cursor: pointer;
		}

		&.active {
			background-color: var(--card);
			/* 0819修改 */
			height: 30px;

			dl,
			.point {
				display: none;
			}
		}

		dl {
			flex: none;
			display: flex;
			height: 80px;
			flex-flow: column wrap;
			padding: 10px 60px 10px 00px;
			flex-flow: row nowrap;

			dd {
				height: 60px;
				width: 150px;

				&:nth-child(2) {
					width: 180px;
				}

				flex: none;
				display: flex;
				flex-flow: column nowrap;
				align-items: flex-start;
				justify-content: center;

				span {
					font: 14px/30px $font;
				}
			}
		}

		.ul {
			padding: 0;
			display: flex;
			flex-flow: row nowrap;
			position: relative;
			z-index: 999;

			li {
				@extend %center;
				align-items: flex-start;
				min-height: 80px;
				flex: auto;
				font: 14px/20px $font;

				&:nth-child(1) {
					width: 180px;
					flex: none;
				}

				&:nth-child(2) {
					width: 180px;
					flex: none;
				}

				&:nth-child(3) {
					padding-left: 20px;
					display: flex;
					flex-flow: column nowrap;
					padding: 10px 60px 10px 20px;
					box-sizing: border-box;
					text-align: left;

					span {
						font: 14px/30px $font;

						&.grey {
							font-size: 14px;
							color: #999;
						}
					}

					a {
						display: inline-block;
						position: relative;
						z-index: 999999999999999999 !important;
						cursor: pointer;
					}
				}
			}
		}

		.point {
			position: absolute;
			background: $c;
			color: #fff;
			height: 30px;
			font: 16px/30px $font;
			padding: 0 10px;
			border-radius: 15px;
			right: 30px;
			top: 25px;
		}

		.ticon {
			position: absolute;
			left: -160px;
			height: 30px;
			line-height: 30px;
			padding: 0 20px 0 88px;
			color: #fff;
			top: 14px;
		}
	}

	.el-timeline {
		padding-left: 140px;

		.el-timeline-item {
			position: relative;
		}
	}

	.child {
		.el-timeline-item__timestamp.is-top {
			background-color: var(--card);
			/* 0819修改 */
			color: #9c9a9a;
			text-align: right;
		}
	}

	.el-timeline-item__timestamp.is-top {
		position: absolute;
		left: -140px;
		width: 120px;
		height: 30px;
		background-color: #2696d2;
		border-radius: 4px;
		color: #fff;
		font: 14px/30px $font;
		padding: 0 0 0 10px;
		top: -6px;
		box-sizing: border-box;
	}
}

.pdou {
	span {
		&::after {
			content: ',';
			display: inline-block;
		}

		&:last-of-type {
			&::after {
				display: none;
			}
		}
	}
}

.origin_name {
	@extend %start;

	>a {
		text-align: center;
	}
}

.inner {
	display: block;
	min-height: 23px;

	span {
		margin-right: 10px;
		font-size: 12px;
		display: inline-block;
		max-width: 200px;
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
		cursor: pointer;
	}

}
</style>
